export default "__VITE_ASSET__rXsubq5J__"